<template>
  <div class="am-referral-program">
    <div class="am-referral-program-header am-main-top-box">
      <div class="am-referral-program-title">Videos</div>
    </div>
    <div class="am-referral-program-content">
      <div style="padding: 10px;">
        <h1 style="text-align: center"><strong>{{videoDisplay.name}}</strong></h1>
        <iframe width="400" height="300" :src="getUrl(videoDisplay.url_link)" frameborder="0" allowfullscreen style="margin-top: -30px; margin-left:14px;"></iframe>
      </div>
      <div>
        <div v-for="index in slides" v-if="index === active && index < videos.length" :key="index">
          <div class="am-referral-program-slides">
            <table>
              <tr>
                <td class="am-referral-program-thumbnails" @click="changeVideo(videos[index-1])">
                  <img :src="videos[index-1].picture">
                </td>
                <td class="am-referral-program-thumbnails" @click="changeVideo(videos[index])">
                  <img :src="videos[index].picture">
                </td>
              </tr>
              <tr>
                <td class="am-referral-program-video-name">
                  {{ videos[index-1].name }}
                </td>
                <td class="am-referral-program-video-name">
                  {{ videos[index].name}}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <span class="am-referral-program-prev" @click="move(-1)">
          <font-awesome-icon icon="chevron-left" size="lg"></font-awesome-icon>
         </span>
        <span class="am-referral-program-next" @click="move(1)">
          <font-awesome-icon icon="chevron-right" size="lg"></font-awesome-icon>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
        /**
         * When Updating make sure you add the image in img folder in legacy as well
         */
      name: 'RefferralProgram',
      videos: [
          {
              name: 'Third Quarter Winner 2019',
              url_link: 'https://player.vimeo.com/video/374689379/',
              picture: require('@/assets/ThirdQuarterly2019.jpg')
          },

          {
              name: 'Second Quarterly Winner 2019',
              url_link: 'https://player.vimeo.com/video/359539595/',
              picture: require('@/assets/SecondQuarterly2019.jpg')
          },

          {
          name: 'First Quarterly Winner 2019',
          url_link: 'https://player.vimeo.com/video/341009571/',
          picture: require('@/assets/FirstQuarterly2019.jpg')

          },

          {
              name: 'Fourth Quarterly Winner 2018',
              url_link: 'https://player.vimeo.com/video/314539954/',
              picture: require('@/assets/ForthQuarterly2018.jpg')
          },

          {
              name: 'Second Quarterly Winner 2017',
              url_link: 'https://player.vimeo.com/video/227738957/',
              picture: require('@/assets/SecondQuarterly2017.jpg')
          },

          {
              name: 'First Quarterly Winner 2017',
              url_link: 'https://player.vimeo.com/video/215535965/',
              picture: require('@/assets/FirstQuarterly2017.jpg')
          }

      ],
      slides: 5,
      active: 1,
      videoDisplay: {
          name: 'Third Quarter Winner 2019',
          url_link: 'https://player.vimeo.com/video/374689379/',
          picture: require('@/assets/ThirdQuarterly2019.jpg')
      }
    }
  },
  methods: {
    move (amount) {
      let newActive
      const newIndex = this.active + amount
      console.log('newindex', newIndex)

      if (newIndex > this.slides) newActive = 1
      if (newIndex === 0) newActive = this.slides
      this.active = newActive || newIndex
      console.log('active', this.active)
    },
    changeVideo (video) {
      console.log('test', this.videoDisplay)
      this.videoDisplay = video
    },
    getUrl () {
      return this.videoDisplay.url_link
    }
  }
}
</script>

<style scoped>
  .am-referral-program {
    background-color: #FFFFFF;
    border: 1px solid #ccc;
    margin: 12px 0px 30px 12px;;
    min-height: 200px;
    font-size: 12px;
    width: 470px;
    float: left;
    position: relative;
  }

  .am-referral-program-header {
    background-repeat: repeat-x;
    color: #fff;
    height: 37px;
    font-size: 12px;
    font-weight: bold;
    padding: 10px;
  }

  .am-referral-program-title {
    float: left;
  }

  .am-referral-program-content {
    padding: 10px;
  }

  .am-referral-program-prev, .am-referral-program-next {
    position: absolute;
    top: 82%;
    width: 50px;
    height: 50px;
    margin-top: -10px;
    margin-left: -18px;
    cursor: pointer;
    line-height: 48px;
    text-align: center;
    text-indent: -2px;
    transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    font-size: 18px;
    color: gray;
  }

  .am-referral-program-next {
    right: 0;
    margin-left: auto;
    margin-right: -5px;
    text-indent: 2px;
  }

  .am-referral-program-next:hover {
    color: black;
  }

  .am-referral-program-prev:hover {
    color: black;
  }

  .am-referral-program-thumbnails img{
    width: 195px;
    height: 120px;
    margin-right: 7.8px;
    cursor: pointer;
  }

  .am-referral-program-video-name {
    text-align: center;
    font-weight: bold;
    font-size: 11px;
    color: #2777A3;
  }

  .am-referral-program-slides {
    padding: 0px 0px 0px 22.5px;
    margin-top: -25px;
  }

</style>
